<template>
  <div v-if="currentUser != null">
    <page-nav-bar
      :is-sticky="true"
      :back-button="false"
      :has-actions="true"
      :has-fullscreen-toggle="false"
      class="is-marginless">
      <div
        slot="page-header"
        class="column is-narrow is-minW300p is-maxW300p has-background-dark is-self-stretched has-text-white columns is-gaplessis-marginless is-vcentered">
        <div class="is-padding-left">
          <span>{{ calendarProgramedActions }} action<span v-if="calendarProgramedActions > 1">s</span> programmée<span v-if="calendarProgramedActions > 1">s</span></span>
        </div>
      </div>

      <div
        slot="page-header"
        class="column is-narrow is-border-right">
        <router-link
          :to="{name: 'CalendarList', params: { year: todayDetail.year, month: todayDetail.month, day: todayDetail.day, panel: 'rdvs' }}"
          class="page-header-btn is-small  is-padding-left-small is-padding-right-small"
          :class="[calendarView === 'CalendarList' ? 'is-primary' : 'has-text-primary']">
          <span class="icon"><i class="fas fa-calendar-week is-size-4 is-padding-right-small"></i></span>
          <span class="has-text-weight-medium">FILTRAGE PAR PÉRIODE</span>
        </router-link>
      </div>

      <div
        slot="page-header"
        class="column is-narrow buttons is-padding-left is-padding-right">
        <router-link
          :to="{name: calendarView, params: { year: previousDate.year, month: previousDate.month, day: previousDate.day }}"
          tag="button"
          class="button is-square is-small is-marginless-bottom">
          <span class="icons"><i class="fal fa-chevron-left"></i></span>
        </router-link>
        <router-link
          :to="{name: calendarView, params: { year: nextDate.year, month: nextDate.month, day: nextDate.day }}"
          tag="button"
          class="button is-square is-small is-marginless-bottom">
          <span class="icons"><i class="fal fa-chevron-right"></i></span>
        </router-link>
      </div>

      <div
        slot="page-header"
        class="column is-narrow">
        <div class="title is-size-5 is-size-4-widescreen">
          <b class="is-uppercase">{{ prettyTitle }}</b>
        </div>
      </div>

      <div
        slot="page-header"
        class="column">
      </div>

      <div
        slot="page-header"
        class="column is-narrow buttons is-padding-left is-padding-right">
        <router-link
          :to="{name: 'CalendarDay', params: { year: todayDetail.year, month: todayDetail.month, day: todayDetail.day, panel: 'rdvs' }}"
          class="button is-small is-transform-none is-marginless-bottom"
          :class="[isToday && $route.name === 'CalendarDay' ? 'is-static' : '']">
          <span class="has-text-grey has-text-weight-medium">Aujourd'hui</span>
        </router-link>
        <router-link
          :to="{name: 'CalendarMonth', params: { year: todayDetail.year, month: todayDetail.month, day: todayDetail.day }}"
          class="button is-small is-transform-none is-marginless-bottom"
          :class="[$route.name === 'CalendarMonth' && isCurrentMonth ? 'is-static' : '']">
          <span class="has-text-grey has-text-weight-medium is-w50p">Mois</span>
        </router-link>
      </div>

      <div
        slot="before-actions"
        class="dropdown is-hoverable is-right">
        <!-- <div class="dropdown-trigger">
          <button aria-haspopup="true" aria-controls="dropdown-menu"
            class="page-header-btn is-small page-header-btn--separetedIco-right is-google_agenda is-small">
            <span class="is-padding-right-small is-small">
              <i class="fab fa-google"></i>
            </span>
            <span>
              hb@okgo.fr
            </span>
            <span class="icon is-medium" aria-haspopup="true" aria-controls="dropdown-menu">
              <i class="fas fa-ellipsis-v"></i>
            </span>
          </button>
        </div> -->
        <!-- <div class="dropdown-menu" id="dropdown-menu" role="menu">
          <div class="dropdown-content has-text-left">
            <div class="dropdown-item">
              <a href="#">
                <span class="icon is-medium"><i class="fas fa-cloud-download"></i></span>
                <span>Importer rendez-vous</span>
              </a>
            </div>
            <div class="dropdown-item">
              <a href="#">
                <span class="icon is-medium"><i class="fas fa-sign-out"></i></span>
                <span>Se Déconnecter</span>
              </a>
            </div>
          </div>
        </div> -->
      </div>

      <!-- Menu Actions -->
      <a
        slot="dropdown-content"
        @click="openCalendarNewAction({fromCalendarDate: rawStartDate})"
        class="dropdown-item">
        <span class="icon is-medium"><i class="fas fa-calendar-plus"></i></span>
        <span class="is-margin-left-xsmall">Nouvelle action</span>
      </a>
      <!-- <a slot="dropdown-content"
        href="#" class="dropdown-item">
        <span class="icon is-medium"><i class="fab fa-google"></i></span>
        <span>Connexion Google</span>
      </a> -->
    </page-nav-bar>
    <spinner-round
      :is-loading="loading"
      v-if="loading"></spinner-round>
    <router-view
      :key="$route.name"
      :raw-start-date="rawStartDate"
      class="is-minH100"></router-view>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { Quickview } from '@/mixins'
import moment from 'moment'
import { clone } from 'lodash'
export default {
  name: 'CalendarVue',
  mixins: [Quickview],
  data () {
    return {
      nbrAction: 1000,
      loading: false,
      today: moment().toDate(),
      endToday: moment().endOf('day').toDate()
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isManager', 'isPromoteur', 'calendarProgramedActions']),
    ...mapState(['currentUser']),
    sentDate () {
      let newDate = `${this.$route.params.day}/${this.$route.params.month}/${this.$route.params.year}`
      newDate = moment(newDate, 'DD/MM/YYYY').startOf('day').toDate()
      return newDate
    },
    rawStartDate () {
      return this.sentDate
    },
    calendarView () {
      return this.$route.name
    },
    prettyTitle () {
      if (this.$route.name === 'CalendarMonth' || this.$route.name === 'CalendarList') {
        return moment(this.rawStartDate).format('MMMM YYYY')
      } else {
        return moment(this.rawStartDate).format('dddd DD MMM YY')
      }
    },
    todayDetail () {
      let result = {
        year: moment(this.today).format('YYYY'),
        month: moment(this.today).format('MM'),
        day: moment(this.today).format('DD')
      }
      return result
    },
    previousDate () {
      let currentDate = clone(this.sentDate)
      let date
      if (this.$route.name === 'CalendarMonth' || this.$route.name === 'CalendarList') {
        date = moment(currentDate).subtract(1, 'M').toDate()
      } else {
        date = moment(currentDate).subtract(1, 'd').toDate()
      }
      let result = {
        year: moment(date).format('YYYY'),
        month: moment(date).format('MM'),
        day: moment(date).format('DD')
      }
      return result
    },
    nextDate () {
      let currentDate = clone(this.sentDate)
      let date
      if (this.$route.name === 'CalendarMonth' || this.$route.name === 'CalendarList') {
        date = moment(currentDate).add(1, 'M').toDate()
      } else {
        date = moment(currentDate).add(1, 'd').toDate()
      }
      let result = {
        year: moment(date).format('YYYY'),
        month: moment(date).format('MM'),
        day: moment(date).format('DD')
      }
      return result
    },
    isToday () {
      let formatedSentDate = moment(this.sentDate).format('DD/MM/YYYY')
      let formatedToday = moment(this.today).format('DD/MM/YYYY')
      return formatedSentDate === formatedToday
    },
    isCurrentMonth () {
      let formatedSentDate = moment(this.sentDate).format('MM/YYYY')
      let formatedToday = moment(this.today).format('MM/YYYY')
      return formatedSentDate === formatedToday
    }
  },
  created () {
    if (!('day' in this.$route.params) && !('month' in this.$route.params) && !('year' in this.$route.params)) {
      this.$router.replace({ name: 'CalendarMonth', params: { year: this.todayDetail.year, month: this.todayDetail.month, day: this.todayDetail.day } })
    }
  }
}
</script>
